<template>
<div></div>
</template>

<script>
export default {
  name: "tool-edit-info-favorite",
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>